import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import {useCollection} from "../../hooks";
import {Aliment} from "../aliments/Aliment";
import {useEffect, useState} from "react";

export default function RecipeName({defaultValue, dataelement, name, stringified}) {
    const aliments = useCollection(Aliment);
    const [value, setValue] = useState(defaultValue)
    const [parts, setParts] = useState(buildParts())
    const grid = 4;

    useEffect(()=>{
        setParts(buildParts());
    }, [dataelement])

    useEffect(()=>{
        setValue(parts.join(', '))
    }, [parts])

    const getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: 'none',
        padding: grid,
        margin: `0 ${grid}px 0 0`,
        // change background colour if dragging
        background: isDragging ? '#71b6f' : 'hsl(0, 0%, 90%)',
        borderRadius: "4px",
        color: "hsl(0, 0%, 20%)",
        whiteSpace: "nowrap",

        // styles we need to apply on draggables
        ...draggableStyle,
    });

    const getListStyle = isDraggingOver => ({
        background: isDraggingOver ? '#71b6f9' : '#394c57',
        display: 'flex',
        padding: "6px 10px",
        border: '2px solid rgba(238, 238, 238, 0.1)',
    });

    function buildParts(){
        let newParts = value.replaceAll(' ', '').split(',').filter( (element)=>{
            return parseValue(element) !== "" && parseValue(element) !== ''});
        if(!newParts.includes("recipe_name") && dataelement.recipe_name){
            newParts.push("recipe_name")
        }
        if(!newParts.includes("prep_var") && dataelement.prep_var){
            newParts.push("prep_var")
        }
        if(!newParts.includes("vege_name") && dataelement.veg_ingredients?.visible_name){
            newParts.push("vege_name")
        }
        if(!newParts.includes("ch_name") && dataelement.carb_ingredients?.visible_name){
            newParts.push("ch_name")
        }
        if(!newParts.includes("prot_name") && dataelement.pro_ingredients?.visible_name){
            newParts.push("prot_name")
        }
        if(!newParts.includes("fat_name") && dataelement.fat_ingredients?.visible_name){
            newParts.push("fat_name")
        }
        if(!newParts.includes("dairy_name") && dataelement.dairy_ingredients?.visible_name){
            newParts.push("dairy_name")
        }
        newParts = handleVisibleIngredients(newParts, dataelement.veg_ingredients);
        newParts = handleVisibleIngredients(newParts, dataelement.carb_ingredients);
        newParts = handleVisibleIngredients(newParts, dataelement.pro_ingredients);
        newParts = handleVisibleIngredients(newParts, dataelement.fat_ingredients);
        newParts = handleVisibleIngredients(newParts, dataelement.dairy_ingredients);
        return newParts;
    }

    function handleVisibleIngredients(newParts, ingredientList){
        ingredientList?.ingredient_list?.forEach((ingredient)=>{
            if(!newParts.includes(ingredient._id) && ingredient.is_visible){
                newParts.push(ingredient._id);
            } else{
                newParts.filter(function(item) {
                    return item !== ingredient._id;
                });
            }
        })
        return newParts;
    }

    function parseValue(value) {
        let aliment = aliments?.filter((element) => {
            return element._id === value;
        })[0];
        if (aliment) {
            return aliment.food_name.nameES;
        }
        switch (value) {
            case "recipe_name":
                return dataelement.recipe_name;
            case "prep_var":
                return dataelement.prep_var;
            case "vege_name":
                return dataelement.veg_ingredients?.visible_name;
            case "ch_name":
                return dataelement.carb_ingredients?.visible_name;
            case "prot_name":/* case "pro_name":*/
                return dataelement.pro_ingredients?.visible_name;
            case "fat_name":
                return dataelement.fat_ingredients?.visible_name;
            case "dairy_name":
                return dataelement.dairy_ingredients?.visible_name;
            case "frut_name":
                return dataelement.fruit_ingredients?.visible_name;
            default:
                return value;
        }
    }

    function array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    };


    function onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        setParts(array_move([...parts], result.source.index, result.destination.index));
        //setValue(array_move([...parts], result.source.index, result.destination.index).join(','))
    }

    if (stringified) {
        let string = "";
        parts.forEach((part, index) => {
            if (part === "prep_var") {
                string += " "
            } else if (index == 1) {
                dataelement.glue_excep_es ? string += " de " : string += " con ";
            } else if (index > 0 && index == parts.length - 1) {
                string += " y "
            } else if (index > 0 && index < parts.length - 1) {
                string += ", "
            }
            string += parseValue(part);
        })
        return <span>{string}</span>
    }

    return <>
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="horizontal">
                {(provided, snapshot) => {
                    return <div className={"form-control-wrapper compact"}>
                        <label>Nombre</label>
                        <div
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                            {...provided.droppableProps}>
                            {parts?.length > 0 ?
                                parts.map((part, index) => {
                                    return <Draggable key={part}
                                                      draggableId={part}
                                                      index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}
                                            >
                                                {parseValue(part)}
                                            </div>
                                        )}
                                    </Draggable>
                                })
                                :
                                "Añade ingredientes a la receta para construir el nombre"}

                            {provided.placeholder}
                        </div>
                    </div>
                }
                }
            </Droppable>
        </DragDropContext>
        <input type={"hidden"} name={name} value={value}/>
    </>
}